import { IPromise } from 'angular';

import * as Common from '../Common/modules';
import { IAvailableMention } from '../Models/AvailableMention';

export interface IOpportunityApiClient {
  getLatestPropertyRecord: (partnerSystemNumber: string) => ng.IPromise<any>;
  getAvailableMentions: (partnerSystemNumber: string) => ng.IPromise<IAvailableMention[]>;
}

export class OpportunityApiClient implements IOpportunityApiClient {
  public static $inject = ["igs.apiClientService"];

  constructor(private igsApiClientService: Common.ApiClientService.Igs.Common.IApiClientService) {}

  public getLatestPropertyRecord = (partnerSystemNumber: string): ng.IPromise<any> => {
    var url = `Opportunities/${partnerSystemNumber}/PropertyRecords/Latest`;
    return this.igsApiClientService.get(url, {
      errorHandler: function (res) {
        if (res.data) {
          console.log(res.data.message);
        }
      },
      nomask: true,
    });
  };

  public getAvailableMentions = (partnerSystemNumber: string): ng.IPromise<IAvailableMention[]> => {
    var url = `Opportunities/${partnerSystemNumber}/AvailableMentions`;
    return this.igsApiClientService.get(url);
  };
}
